import type { GetProviderTypesRequest } from "@xng/xng-backend";
import { API_USERS_BACKEND } from "../../api";
import useApiQueryData from "../use_api_query_data";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";

type Data = Awaited<ReturnType<typeof API_USERS_BACKEND.getProviderTypes>>;
type QueryParams = GetProviderTypesRequest;

const useApiQueryGetProviderTypes = (
  paramObject: XNGApiQueryParamObject<QueryParams, Data>,
) => {
  return useApiQueryData({
    queryFn: async () => await API_USERS_BACKEND.getProviderTypes(paramObject.queryParams),
    queryKey: ["getProviderTypes", paramObject.queryParams.id],
    ...(paramObject.options),
  });
};

export default useApiQueryGetProviderTypes;
